import { render, staticRenderFns } from "./vCheckboxOTP.vue?vue&type=template&id=cff03b90&scoped=true"
import script from "./vCheckboxOTP.vue?vue&type=script&lang=js"
export * from "./vCheckboxOTP.vue?vue&type=script&lang=js"
import style0 from "./vCheckboxOTP.vue?vue&type=style&index=0&id=cff03b90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff03b90",
  null
  
)

export default component.exports